import { render, staticRenderFns } from "./AppHanKanaField.vue?vue&type=template&id=b37be1d4&"
import script from "./AppHanKanaField.vue?vue&type=script&lang=ts&"
export * from "./AppHanKanaField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports